<svg class="dashed-line" width="100%" height="1" viewBox="0 0 100% 1" xmlns="http://www.w3.org/2000/svg">
  <line x1="0" y1="0" x2="100%" y2="0" stroke-width="1" stroke="#B1B1B1" stroke-dasharray="3"/>
</svg>
